export default __webpack_public_path__ + "static/736-88dfde1e6c32bd9e67ed3bedadc245dc.gif";